import { Home, Book, Info, Mail, X, Phone, PhoneCall } from "lucide-react"; // Importing Lucide React icons
import { useState } from "react";
import { Link } from "react-router-dom";
//@ts-ignore
import logo from "../assets/logo/ByteSplash_Logo.png";
import "./css/Header.css";

/*************  ✨ Codeium Command ⭐  *************/
/**
 * Header component that represents the navigation bar for the Learning Management System.
 * It includes a logo, navigation links, and contact information.
 * 
 * State:
 * - isOpen: Boolean state to manage the visibility of the mobile menu.
 * - isDropdownOpen: Boolean state to manage the visibility of dropdowns (unused currently).
 * 
 * Returns:
 * - A responsive header with a logo, login link, and contact information.
 * - On smaller screens, displays a toggleable mobile menu with navigation links.
 */

/******  fbe8987d-0227-423d-a163-d16b6b4d3f78  *******/
function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    return (
        <header className="flex justify-between items-center p-2 bg-white text-gray-400 shadow-lg">
            <div className="flex flex-col items-center mb-0 px-2">
                <img src={logo} alt="Logo" width={210} className="h-10" /> {/* Adjusted width to a more common value */}
                <span className="font-bold text-sm mt-0">Learning Management System</span>
            </div>
            <nav className="hidden md:flex space-x-4">

            </nav>
            <div className="hidden md:flex items-center">
                <Link
                    to="/login"
                    className="text-white bg-[#0071bd] border-2 border-transparent hover:bg-gray-200 hover:text-[#0071bd] transition rounded-md px-3 py-2 font-bold"
                >
                    Login to LMS
                </Link>
                <a
                    href="tel:+918660803099"
                    className="flex items-center px-2 text-gray-500 border-2 border-transparent hover:bg-gray-200 hover:text-[#0071bd] transition rounded-md px-3 ml-3 py-2 font-bold"
                >
                    <Phone
                        size={20}
                        className="text-gray-500 transition hover:text-[#0071bd]"
                    />
                    <span className="ml-2 text-gray-500 hover:text-[#0071bd]">
                        +91 8660803099
                    </span>
                </a>
                <a
                    href="mailto:enquires@bytesplash.in"
                    className="flex items-center  px-2 text-gray-500 border-2 border-transparent hover:bg-gray-200 hover:text-[#0071bd] transition rounded-md px-3 py-2 font-bold ml-4"
                >
                    <Mail
                        size={20}
                        className="text-gray-500 transition hover:text-[#0071bd]"
                    />
                    <span className="ml-2 text-gray-500 hover:text-[#0071bd]">
                        enquires@bytesplash.in
                    </span>
                </a>
            </div>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="md:hidden focus:outline-none"
            >
                <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 6h16M4 12h16m-7 6h7"
                    />
                </svg>
            </button>
            {isOpen && (
                <div className="fixed inset-0 bg-gray-800 bg-opacity-75 z-50 transition-opacity duration-300 ease-in-out">
                    <div className="fixed top-0 right-0 w-64 h-full bg-white p-4 shadow-lg z-50 transform transition-transform duration-300 ease-in-out translate-x-0">

                        <button
                            onClick={() => setIsOpen(false)}
                            className="absolute top-4 right-4 text-gray-800 focus:outline-none"
                        >
                            <X size={24} />
                        </button>
                        <div className="flex items-center mb-4 mt-8">
                            <img src={logo} alt="Logo" className="w-120 h-10" />
                        </div>
                        <ul className="mt-4 space-y-2">

                            <li>
                                <Link
                                    to="/login"
                                    onClick={() => setIsOpen(false)}

                                    className="flex items-center py-2 text-white bg-[#0071bd] hover:bg-gray-200 hover:text-[#0071bd] transition rounded-md px-6 mt-6 mb-6 font-bold"
                                >
                                    <Mail size={20} className="mr-2" /> Login to LMS
                                </Link>
                            </li>
                            <li>
                                <a
                                    href="tell:+916301062858"
                                    className="flex items-center py-2 px-2 hover:bg-gray-200 hover:text-[#0071bd] transition rounded-md px-3 font-bold"
                                >
                                    <PhoneCall size={20} className="mr-2" /> +91 6301062858
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:enquires@bytesplash.in"
                                    className="flex text-sm items-center py-2 px-2 hover:bg-gray-200 hover:text-[#0071bd] transition rounded-md px-3 font-bold"
                                >
                                    <Mail size={20} className="mr-2" /> enquires@bytesplash.in
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            )}
        </header>
    );
}

export default Header;
